import React from "react";
import DoserRecipePane, { RECIPE_COLOURS } from "./DoserRecipePane";
import LoadingSpinner from "../loadingSpinner";
import { wsTrans } from "../../utils/utils";
import { withTimeout, contSaveSchedule, readXBoards, readJPro, setSensorNames
} from "../C18AiUtils";
import {getSensorsZone} from '../C18utils'
import { cl, globs, getRandomString } from "../../../components/utils/utils";

const pageWrap = {
  fontFamily: "system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  padding: 20,
  width: "100%",
  boxSizing: "border-box",
};

const titleTyp = {
  fontSize: 28,
  fontWeight: 700,
  color: "#1a2332",
  margin: "0 0 6px 0",
};

const subTyp = {
  fontSize: 13,
  color: "#8a9aac",
  marginBottom: 18,
};

const gridTyp = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
  gap: 16,
  alignItems: "stretch",
};

const newCardTyp = {
  minHeight: 180,
  borderRadius: 12,
  border: "2px dashed #c5ced8",
  background: "#fafbfc",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  cursor: "pointer",
  color: "#8a9aac",
  fontSize: 15,
  fontWeight: 600,
  fontFamily: "inherit",
  width: "100%",
  boxSizing: "border-box",
};

function blankConcs() {
  return new Array(64).fill(0);
}

function normalizeRecipe(r, colourIndex) {
  return {
    recipeId: r.recipeId,
    name: r.name || "",
    concs: Array.isArray(r.concs) ? r.concs.slice(0, 64) : blankConcs(),
    color: r.color || RECIPE_COLOURS[colourIndex % RECIPE_COLOURS.length],
    notes: r.notes != null ? r.notes : "",
  };
}

function cloneRecipe(r) {
  return {
    ...r,
    concs: (r.concs || blankConcs()).slice(0),
  };
}

export default class DoserRecipes2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      recipes: [],
      jPlus: [],
      schedule: [],
      editId: null,
      draft: null,
    };
    this.subscribe_savePageEvent = globs.events.subscribe(
      "savePageEvent",
      this.savePage
    );
  }

  componentDidMount() {
    this.loadInfo();
  }

  componentWillUnmount() {
    if (this.subscribe_savePageEvent && this.subscribe_savePageEvent.remove) {
      this.subscribe_savePageEvent.remove();
    }
  }

  loadInfo = async () => {
    const pa = this.props.parms;
//     cl(this.props)
    let {recipes,schedule,jPlus,xBoards,zoneInfo}=this.props
//     const body = { zoneId: pa.zone };
//     const res = await wsTrans("usa", {
//       cmd: "cRest",
//       uri: "/s/pearlDoser",
//       method: "retrieve",
//       sessionId: globs.userData.session.sessionId,
//       body,
//     });
//     const stateVals = { loaded: true };
// //     cl(res)
//     for (const val of res.data) {
//       stateVals[val.type] = val.value;
//     }
    recipes = (/*stateVals.*/recipes || [])
      .filter((r) => r.recipeId && r.recipeId !== "none")
      .map((r, i) => normalizeRecipe(r, i));
//     const zone = globs.zonesInfo.info.find((z) => z.zoneId === pa.zone);
    let zInd=zoneInfo.siteZoneIndex
//     const xBoards=readXBoards(zInd)
    let jPro=readJPro(zInd,xBoards,/*stateVals.*/jPlus?.length??0)
    this.setState({
      loaded: true,
      zInd,
      recipes,
      jPro,
      jPlus,
      schedule,
//       jPlus: stateVals.jPlus || [],
//       schedule: stateVals.schedule || [],
    });
  };

  doSaveField = async (field, value) => {
    const pa = this.props.parms;
    cl(`save ${field}`)
    await wsTrans("usa", {
      cmd: "cRest",
      uri: "/s/pearlDoser",
      method: "update",
      sessionId: globs.userData.session.sessionId,
      body: {
        zoneId: pa.zone,
        type: field,
        value,
      },
    });
  };

  setSavePage = (set) => {
    globs.events.publish("savePageEnable", set);
    if (this.props.onChange) {
      this.props.onChange({
        type: "change",
        value: set ? this.savePage : null,
      });
    }
  };

  doSavePage = async () => {
//     cl(this.state)
    const { editId, draft } = this.state;
    if (editId && draft) {
      await this.commitDraft(false);
    }
  };

  saveSensorNames=async()=>{
    let {zone}=this.props.parms
    let zoneInfo=globs.zonesInfo.info.find(z=>z.zoneId==zone)
    let sensors=getSensorsZone(zone).sensorNames
    setSensorNames(sensors)
    cl("saveSensorNames")
    await wsTrans("usa", {cmd: "cRest", uri: "/s/sensors", method: "update",
      sessionId: globs.userData.session.sessionId,
      body: {zoneId: zone, siteId:zoneInfo.siteId, sensorNames:sensors}})

  }

  savePage = async () => {
    const res = await withTimeout(this.doSavePage(), 5000);
    await this.saveSensorNames()
//     cl(res);
    if (res !== "to") {
      globs.events.publish("saveOK", true);
    }
  };

  getActiveNutrients = () => {
    const { jPlus } = this.state;
    const out = [];
    (jPlus || [])
      .filter((jp) => !jp.notUsed)
      .forEach((jp, jpInd) => {
        (jp.nutes || []).forEach((name, slot) => {
          if (name && name !== "None") {
            out.push({
              name,
              concIndex: jpInd * 16 + slot,
            });
          }
        });
      });
    return out;
  };

  nutrientsForRecipe = (recipe) => {
    const concs = recipe.concs || blankConcs();
    return this.getActiveNutrients().map((n) => ({
      name: n.name,
      key: n.concIndex,
      concIndex: n.concIndex,
      conc: concs[n.concIndex] || 0,
    }));
  };

  isScheduled = (recipeId) => {
    return (this.state.schedule || []).some(
      (s) => s && s.recipeId === recipeId && s.recipeId !== "none"
    );
  };

  beginEdit = (recipe) => {
    this.setState({
      editId: recipe.recipeId,
      draft: cloneRecipe(recipe),
    });
  };

  cancelEdit = () => {
    this.setState({ editId: null, draft: null });
    this.setSavePage(false);
  };

  commitDraft = async (clearEdit = true) => {
//     cl(this.state)
    const { draft, recipes, schedule, jPlus, jPro, zInd } = this.state;
    if (!draft) return;

    const toSave = cloneRecipe(draft);
    delete toSave._isNew;

    const exists = recipes.some((r) => r.recipeId === draft.recipeId);
    const nextRecipes = exists
      ? recipes.map((r) =>
          r.recipeId === draft.recipeId ? toSave : r
        )
      : [...recipes, toSave];

    this.setState({
      recipes: nextRecipes,
      ...(clearEdit ? { editId: null, draft: null } : {}),
    });
    await this.doSaveField("recipes", nextRecipes);
    await contSaveSchedule(schedule, recipes, jPlus, jPro, zInd);
    this.setSavePage(false);
  };

  deleteDraft = async () => {
    const { draft, recipes, schedule } = this.state;
    if (!draft) return;

    const nextRecipes = recipes.filter((r) => r.recipeId !== draft.recipeId);
    const nextSchedule = (schedule || []).map((s) => {
      if (s.recipeId !== draft.recipeId) return s;
      return { ...s, recipeId: "none", dayMins: 0, durMins: 0 };
    });

    this.setState({
      recipes: nextRecipes,
      schedule: nextSchedule,
      editId: null,
      draft: null,
    });
    await this.doSaveField("recipes", nextRecipes);
    await this.doSaveField("schedule", nextSchedule);
    this.setSavePage(false);
  };

  newRecipe = () => {
    const { recipes, editId } = this.state;
    if (editId) return;

    const recipe = normalizeRecipe(
      {
        recipeId: getRandomString(16),
        name: `New Recipe ${recipes.length + 1}`,
        concs: blankConcs(),
        notes: "",
      },
      recipes.length
    );
    const draft = cloneRecipe(recipe);
    draft._isNew = true;
    this.setState({
      recipes: [...recipes, recipe],
      editId: recipe.recipeId,
      draft,
    });
  };

  onPaneChange = (recipeId, values) => {
    const { editId, draft } = this.state;

    switch (values.type) {
      case "edit": {
        const recipe = this.state.recipes.find((r) => r.recipeId === recipeId);
        if (recipe) this.beginEdit(recipe);
        break;
      }
      case "name":
        if (editId === recipeId && draft) {
          this.setState({ draft: { ...draft, name: values.value } });
          this.setSavePage(true);
        }
        break;
      case "color":
        if (editId === recipeId && draft) {
          this.setState({ draft: { ...draft, color: values.value } });
          this.setSavePage(true);
        }
        break;
      case "notes":
        if (editId === recipeId && draft) {
          this.setState({ draft: { ...draft, notes: values.value } });
          this.setSavePage(true);
        }
        break;
      case "conc":
        if (editId === recipeId && draft) {
          const concs = draft.concs.slice(0);
          const idx = values.index;
          if (idx != null && idx >= 0 && idx < concs.length) {
            concs[idx] = values.value;
          }
          this.setState({ draft: { ...draft, concs } });
          this.setSavePage(true);
        }
        break;
      case "save":
        this.commitDraft(true);
        break;
      case "cancel":
        if (draft && draft._isNew) {
          this.setState({
            recipes: this.state.recipes.filter(
              (r) => r.recipeId !== draft.recipeId
            ),
            editId: null,
            draft: null,
          });
          this.setSavePage(false);
        } else {
          this.cancelEdit();
        }
        break;
      case "delete":
        this.deleteDraft();
        break;
      default:
        break;
    }
  };

  renderNewCard() {
    return (
      <button type="button" style={newCardTyp} onClick={this.newRecipe}>
        <span style={{ fontSize: 36, lineHeight: 1, fontWeight: 400 }}>+</span>
        <span>New Recipe</span>
      </button>
    );
  }

  render() {
    const { loaded, recipes, editId, draft } = this.state;
    const { units } = this.props;

    if (!loaded) {
      return <LoadingSpinner message="loading recipes..." />;
    }

    const activeNutrients = this.getActiveNutrients();

    return (
      <div style={pageWrap}>
        <h2 style={titleTyp}>Recipes</h2>
        <div style={subTyp}>
          {recipes.length} recipe{recipes.length === 1 ? "" : "s"}
          {" · "}
          {activeNutrients.length} nutrient
          {activeNutrients.length === 1 ? "" : "s"} in use (set on JPro Setup)
          {" · "}
          edits save per recipe
        </div>

        <div style={gridTyp}>
          {recipes.map((recipe) => {
            const isEditing = editId === recipe.recipeId;
            const data = isEditing && draft ? draft : recipe;
            return (
              <div key={recipe.recipeId}>
                <DoserRecipePane
                  mode={isEditing ? "config" : "status"}
                  name={data.name}
                  color={data.color}
                  notes={data.notes}
                  scheduled={this.isScheduled(recipe.recipeId)}
                  nutrients={this.nutrientsForRecipe(data)}
                  units={units}
                  onChange={(v) => this.onPaneChange(recipe.recipeId, v)}
                />
              </div>
            );
          })}
          {!editId && this.renderNewCard()}
        </div>
      </div>
    );
  }
}
